import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService, AppAuthService } from './@core/utils';
import { Member } from './@core/models';
import { MemberService } from './@core/data';
import { environment } from '../environments/environment';
import { NbIconLibraries } from '@nebular/theme';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MaintenanceService } from './shared/maintenance/maintenance.service';

@Component({
  selector: 'app-decathlon-exchange',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  translateService: TranslateService;

  user: Member;

  /**
   * Check if app is in maintenance mode
   */
  maintenance = false;

  constructor(
    private memberService: MemberService,
    private analytics: AnalyticsService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    translateService: TranslateService,
    iconLibraries: NbIconLibraries,
    private appAuth: AppAuthService,
    private maintenanceService: MaintenanceService,
  ) {
    this.translateService = translateService;
    const availableLanguages = environment.availableLanguages;

    translateService.addLangs(availableLanguages);
    translateService.setDefaultLang('en');

    iconLibraries.registerFontPack('fa', {packClass: 'fa', iconClassPrefix: 'fa'});
    iconLibraries.registerFontPack('far', {packClass: 'far', iconClassPrefix: 'fa'});
    iconLibraries.registerFontPack('ion', {iconClassPrefix: 'ion'});
    iconLibraries.registerFontPack('socicon', {iconClassPrefix: 'socicon'});

    this.matIconRegistry
      .addSvgIconSetInNamespace('sprite',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/sprites/sprite.svg'));
  }

  fetchUser() {
    const userUuid = this.appAuth.getAuthenticatedUserUuid();
    this.memberService.populate(userUuid);
  }

  ngOnInit(): void {
    this.appAuth.authenticationRedirectFlow().then(() => {
      if (this.appAuth.isAuthenticated()) {
        this.fetchUser();
      }
    });

    this.memberService.currentUser.subscribe((user) => {
      this.user = user;

      if (user && user.uuid) {
        // If maintenance mode is enabled, check if the current user is allowed to access the app
        this.maintenance = this.maintenanceService.shouldShowMaintenance(user);

        const userPermissions = user.roles;

        // Add user info to Datadog RUM
        if (environment.datadog && typeof DD_RUM !== 'undefined') {
          DD_RUM.setUser({
            id: user?.uuid,
            name: user?.display_name,
            email: user?.mail ? user.mail[0] : undefined,
            permissions: userPermissions,
          });
        }
      }
    });

    this.analytics.trackPageViews();
  }
}
